/**
 * 按钮权限
 * 从用户store中获取用户按钮权限
 * eg: ['vant', 'edit', 'add', 'see', ...]
 *
 */

// import { UserModule } from '@/store/modules/user'
const jurisdiction = ["vant", "edit", "add", "see"]; // 用户按钮权限
const boton = {
  // 当指令绑定在对应元素时触发。只会触发一次
  beforeMount() {},

  // 当对应元素被插入到 DOM 的父元素时触发
  mounted(el, { value }) {
    let permissionRoles;
    value && typeof value === "string" && (permissionRoles = [value]);
    value &&
      value instanceof Array &&
      value.length > 0 &&
      (permissionRoles = value);
    if (
      permissionRoles &&
      permissionRoles instanceof Array &&
      permissionRoles.length > 0
    ) {
      const hasPermission = jurisdiction.some(role => {
        return permissionRoles.includes(role);
      });
      if (!hasPermission) {
        el.parentNode.removeChild(el);
      }
    } else {
      throw new Error("need roles");
    }
  },

  // 会在元素自身更新前触发
  beforeUpdate() {},

  // 当传进来的值更新的时候触发
  updated() {},

  // 当元素自身被卸载前触发
  beforeUnmount() {},

  // // 指令与元素解绑的时候，移除事件绑定
  unmounted() {}
};

export default boton;
